export default "__VITE_ASSET__CGxxNh8K__"